import React, {FC, useEffect, useState} from "react";
import {Button, Typography} from "@mui/material";
import {
    AddVariableDialogActionsStyled,
    AddVariableDialogContentStyled,
    AddVariableDialogTitleStyled
} from "../addVariableDialog/styled";
import {TCommonDialogOpenEventData} from "../../../types";
import {commonDialogOpenEventName} from "../../../constants";
import {createEventCommonDialogOpen} from "../../../helpers";
import {SmallSizeDialogStyled} from "../manageActorsDialog/styled";

export const IsNoRecipientsDialog: FC = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const type: TCommonDialogOpenEventData["type"] = "noRecipients";
    const text = 'There are no recipients in the document. Please add at least one recipient to continue.';
    const title = 'No recipients';

    const handleClose = () => {
        createEventCommonDialogOpen({type, isOpen: false, data: []});
    };

    const handleEvent = (ev: Event) => {
        const {detail} = ev as CustomEvent<TCommonDialogOpenEventData>;
        if (detail.type === type) {
            setIsOpen(detail.isOpen);
        }
    }

    useEffect(() => {
        document.addEventListener(commonDialogOpenEventName, handleEvent);
        return () => {
            document.removeEventListener(commonDialogOpenEventName, handleEvent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SmallSizeDialogStyled open={isOpen} onClose={handleClose}>
            <AddVariableDialogTitleStyled>
                {title}
            </AddVariableDialogTitleStyled>

            <AddVariableDialogContentStyled>
                <Typography>{text}</Typography>
            </AddVariableDialogContentStyled>

            <AddVariableDialogActionsStyled>
                <Button variant={"text"} onClick={handleClose}>{'Close'}</Button>
                {/*<Button variant={"contained"} onClick={onConfirm}>{'Save'}</Button>*/}
            </AddVariableDialogActionsStyled>
        </SmallSizeDialogStyled>
    )
}
